export const FLAG_GETTING_PAYMENTS = 'FLAG_GETTING_PAYMENTS';
export const GET_PAYMENTS = 'GET_PAYMENTS';
export const CLEAR_PAYMENTS = 'CLEAR_PAYMENTS';
export const FLAG_PAYMENT_ACTIVITY = 'FLAG_PAYMENT_ACTIVITY';
export const GET_PAYMENT = 'GET_PAYMENT';
export const CLEAR_PAYMENT = 'CLEAR_PAYMENT';
